import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { registrationInputMaxLength } from "app/utils/const";
import { useEffect, useState } from "react";
import { IntlShape } from "react-intl";
import BuildingCity from "../BuildingCity/BuildingCity";

type Props = {
  handleChange: (id: string, value: string) => void;
  address: string;
  postCode: string;
  intl: IntlShape;
  addressValidationError: boolean;
  postCodeValidationError: boolean;
  isCanadaSelected: boolean;
  building: string;
  city: string;
  buildingValidationError: boolean;
  cityValidationError: boolean;
};

const AddressLinePostCode = ({
  handleChange,
  address,
  postCode,
  intl,
  addressValidationError,
  postCodeValidationError,
  isCanadaSelected,
  building,
  city,
  buildingValidationError,
  cityValidationError,
}: Props) => {
  const [errorAddress, setErrorAddress] = useState<string>("");
  const [errorPostCode, setErrorPostCode] = useState<string>("");

  const validateAddress = (id: string, value: string) => {
    if (value.length < 2) {
      setErrorAddress(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorAddress("");
    }
  };

  const validatePostCode = (id: string, value: string) => {
    if (value.length < 2) {
      setErrorPostCode(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorPostCode("");
    }
  };

  useEffect(() => {
    if (addressValidationError) {
      validateAddress("dateOfBirth", "");
    }
    if (postCodeValidationError) {
      validatePostCode("gender", "");
    }
  }, [postCodeValidationError, addressValidationError]);

  return (
    <>
      <div className="form-details__row form-details__single_col">
        <InputWithLabel
          label={intl.formatMessage({
            id: isCanadaSelected
              ? "home-register-select-street"
              : "registrations-address-line",
          })}
          inputId={"address"}
          value={address}
          onValueChange={handleChange}
          key={"address"}
          type={"text"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: isCanadaSelected
              ? "registrations-enter-street"
              : "registrations-enter-address",
          })}
          validateInput={true}
          error={errorAddress}
          handleValidation={validateAddress}
        />
      </div>
      {isCanadaSelected && (
        <BuildingCity
          handleChange={handleChange}
          building={building}
          city={city}
          intl={intl}
          buildingValidationError={buildingValidationError}
          cityValidationError={cityValidationError}
        />
      )}
      <div className="form-details__row form-details__single_col">
        <InputWithLabel
          label={intl.formatMessage({
            id: "cashier-postcode",
          })}
          inputId={"postCode"}
          value={postCode}
          onValueChange={handleChange}
          key={"postCode"}
          type={"text"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: "cashier-enter-postcode",
          })}
          validateInput={true}
          error={errorPostCode}
          handleValidation={validatePostCode}
        />
      </div>
    </>
  );
};

export default AddressLinePostCode;
